export const PRODUCT_GET_LISTING = "@Product_GetListing";


// WEBPACK FOOTER //
// ./src/app/store/reducers/products/ActionsProductListingReducer.ts